/* eslint-disable */
import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import language from '../../assets/languages/language';
import ProfileInfo from '../Profile/ProfileInfo/ProfileInfo';
import FD from '../RestAPI/fetchData';
import AppRoutes from '../config/AppRoutes';
import App_data from '../config/App_data';
import Loader from '../../common/loader';
import userStore from "../../store/userStore";
class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      MessageTitle: `${language.LC().ALERT}`,
      MessageContent: `${language.LC().ERROR}`,
      avatarData: '',
      avatarURL: '',
      token: '',
      idname: '',
      email: '',
      userName: '',
      ValidToken: false,
      pastPassword: '',
      social: false,
      examData: '',
      selected_language: '',
      dropdownOpen: false,
      username: '',
      user_id: '',
      url: '',
      noOfComments: '',
      noOfPosts: '',
    };
    this.toggleAlert = this.toggleAlert.bind(this);
    this.toggleAlertvalidation = this.toggleAlertvalidation.bind(this);
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.route.path !== this.props.route.path) {
      window.scrollTo(0, 0);
      const u = window.location.href;
      const r = u.split('/');
      const url = r[4];
      await this.setState({ url: url });
    }
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    const u = window.location.href;
    const r = u.split('/');
    const url = r[4];
    await this.setState({ url: url });
    const username = this.props.params.username;
    const un = u.split('-');
    const user_id = un[un.length - 1];
    await this.setState({ user_id: user_id, username: username });
    // console.log(username)
    const data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    // await FD.callAPI(`${App_data.backend_api}/user/getProfileInfo`, data).then((resp) => {
    const userProfile = await userStore.getUserProfile();
    if (userProfile) {
        this.setState({ ValidToken: true });
        if (userProfile.imageUrl == '' || userProfile.imageUrl == undefined) {
          this.setState({
            avatarURL: `${App_data.frontend_url}/img/avatars/defaultProfileImage.jpg`,
          });
        } else {
          this.setState({ avatarURL: userProfile.imageUrl });
        }
        this.setState({
          userName: userProfile.username,
          email: userProfile.email,
          examDate: userProfile.exam,
          examLocation: userProfile.location,
          pastPassword: userProfile.password,
          social: userProfile.isSocial,
          age: userProfile.age,
          occupation: userProfile.occupation,
          education: userProfile.education,
          profileStatus: userProfile.isProfilePrivate,
          selected_language: userProfile.selected_language
            ? userProfile.selected_language
            : 'EN',
        });
        // localStorage.getItem('domainApp') === 'WORLD';
      } else {
        this.setState({ ValidToken: false });
      }
      // return resp;
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  async _getAllDiscussions() {
    this.context.router.push({
      pathname: `/profile/discussions/${this.state.username}`,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        user_id: this.state.user_id,
      },
    });
  }

  async _getAllComments() {
    this.context.router.push({
      pathname: `/profile/comments/${this.state.username}`,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        user_id: this.state.user_id,
      },
    });
  }

  onFileChange = (files) => {
    const file = files[0];
    if (!file) return;
    const avatarURL = URL.createObjectURL(file);
    this.setState({ avatarURL, avatarData: file });
  };

  toggleAlert() {}

  toggleAlertvalidation() {}

  changePassword() {
    let { username } = this.state;
    if (this.props.params.username && this.props.params.username !== username) {
      username = this.props.params.username;
      this.setState({
        username,
      });
    }
    if (this.state.pastPassword === null || this.state.pastPassword === '') {
      this.context.router.push({
        pathname: '/setpassword/',
        state: {
          token: this.state.token,
          idname: this.state.idname,
          selectedMenu: localStorage.getItem('selectedmenu'),
        },
      });
    } else {
      this.context.router.push({
        pathname: `/changepassword/${localStorage.getItem('selectedmenu')}/${username}`,
        state: {
          token: this.state.token,
          idname: this.state.idname,
          selectedMenu: localStorage.getItem('selectedmenu'),
          username: this.state.username,
        },
      });
    }
  }

  _savedQuestion() {
    if (localStorage.getItem('selectedmenu') === 'frm') {
      this.context.router.push({
        pathname: '/frmsavedquestion/',
        state: {
          token: this.state.token,
          idname: this.state.idname,
          selectedMenu: 'frm',
          username: this.state.username,
        },
      });
    }
    if (localStorage.getItem('selectedmenu') === 'cfa') {
      this.context.router.push({
        pathname: '/cfasavedquestion/',
        state: {
          token: this.state.token,
          idname: this.state.idname,
          username: this.state.username,
        },
      });
    }
    if (localStorage.getItem('selectedmenu') === 'cfa_2') {
      this.context.router.push({
        pathname: '/cfa2_savedquestion/',
        state: {
          token: this.state.token,
          idname: this.state.idname,
          username: this.state.username,
        },
      });
    }
    if (localStorage.getItem('selectedmenu') === 'cfa_3') {
      this.context.router.push({
        pathname: '/cfa3_savedquestion/',
        state: {
          token: this.state.token,
          idname: this.state.idname,
          username: this.state.username,
        },
      });
    }
    if (localStorage.getItem('selectedmenu') === 'soa_p') {
      this.context.router.push({
        pathname: '/soa/probability/savedquestion/',
        state: {
          token: this.state.token,
          idname: this.state.idname,
          username: this.state.username,
        },
      });
    }
    if (localStorage.getItem('selectedmenu') === 'soa_fm') {
      this.context.router.push({
        pathname: '/soa/financialmathematics/savedquestion/',
        state: {
          token: this.state.token,
          idname: this.state.idname,
          username: this.state.username,
        },
      });
    }
  }

  _orderHistory() {
    let { username } = this.state;
    if (this.props.params.username && this.props.params.username !== username) {
      username = this.props.params.username;
      this.setState({
        username,
      });
    }
    this.context.router.push({
      pathname: `/orderhistory/${localStorage.getItem('selectedmenu')}/${username}`,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: localStorage.getItem('selectedmenu'),
        username: this.state.username,
      },
    });
  }

  _subscriptionDetails = (event, recurringPayment = false) => {
    let { username } = this.state;
    if (this.props.params.username && this.props.params.username !== username) {
      username = this.props.params.username;
      this.setState({
        username,
      });
    }
    let pathname = `/subscriptiondetail/${localStorage.getItem('selectedmenu')}/${username}`;
    if (recurringPayment) {
      pathname = AppRoutes.RECURRING_PLAN_DETAILS.replace(
        '(/:selectedMenu)',
        `/${localStorage.getItem('selectedmenu')}`,
      ).replace('(/:username)', `/${username}`);
    }
    this.context.router.push({
      pathname,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: localStorage.getItem('selectedmenu'),
        username: this.state.username,
      },
    });
  };

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  render() {
    let changepassword_var = '';
    {
      if (this.state.pastPassword === null || this.state.pastPassword === '') {
        changepassword_var = (
          <button
            type='button'
            className='margin_bottom_20 btn_full_width btn btn-primary pointer_class'
            onClick={this.changePassword.bind(this)}
          >
            {language.LC().SET_PASSWORD}
          </button>
        );
      } else if (this.state.pastPassword !== null) {
        changepassword_var = (
          <button
            type='button'
            className='margin_bottom_20 btn_full_width btn btn-primary pointer_class'
            onClick={this.changePassword.bind(this)}
          >
            {language.LC().CHANGE_PASSWORD}
          </button>
        );
      }
    }

    const validRender = (
      <div className='row'>
        <div className='col-sm-12 col-md-12'>
          <Modal
            isOpen={this.state.alert_status}
            toggle={this.toggleAlert}
            className={`modal-primary ${this.props.className}`}
          >
            <ModalHeader toggle={this.toggleAlert}>{this.state.MessageTitle}</ModalHeader>
            <ModalBody>{this.state.MessageContent}</ModalBody>
          </Modal>
          <Modal
            isOpen={this.state.alert_status}
            toggle={this.toggleAlertvalidation}
            className={`modal-primary ${this.props.className}`}
          >
            <ModalHeader toggle={this.toggleAlertvalidation}>{this.state.MessageTitle}</ModalHeader>
            <ModalBody>{this.state.MessageContent}</ModalBody>
          </Modal>

          <div className='row frm-profile-wraps'>
            <div className='col-sm-12 col-md-6 col-lg-4 col-xl-3'>
              <div className='card margin_bottom_20'>
                <div className='card-block padding_0'>
                  <div className='row'>
                    <div className='col-sm-12 align-self-center text-center'>
                      <div className='profile_img_wrap'>
                        <Dropzone
                          style={{ cursor: 'pointer', border: 'none' }}
                          multiple={false}
                          accept='image/*'
                          onDrop={this.onFileChange}
                        >
                          <div className='profile-img-update-wrap'>
                            <div
                              className='profile-img'
                              style={{
                                backgroundImage: `url(${this.state.avatarURL})`,
                              }}
                            />
                          </div>
                          <div className='camera_wrapper'>
                            <img
                              src={`${App_data.frontend_url}/img/profile/plus_sm_ico.png`}
                              className=''
                              alt=''
                            />
                          </div>
                        </Dropzone>
                        <h6>{this.state.userName}</h6>
                      </div>

                      <ul className='profile_link_wrapper profilebtnHover'>
                        <li className='margin_bottom_20'>
                          <button
                            type='button'
                            className='blue_btn'
                            onClick={this._orderHistory.bind(this)}
                          >
                            <i className='fa fa-shopping-bag me-2' /> {language.LC().ORDER_HISTORY}
                          </button>
                        </li>
                        <li className='margin_bottom_20'>
                          <button
                            type='button'
                            className='blue_btn'
                            onClick={(e) => this._subscriptionDetails(e)}
                          >
                            <i className='fa fa-credit-card me-2' />{' '}
                            {language.LC().SUBSCRIPTION_DETAIL}
                          </button>
                        </li>
                        <li className='margin_bottom_20'>
                          <button
                            type='button'
                            className='blue_btn'
                            onClick={(e) => this._subscriptionDetails(e, true)}
                          >
                            <i className='fa fa-calendar me-2' />{' '}
                            {language.LC().MONTHLY_SUBSCRIPTION_DETAIL}
                          </button>
                        </li>
                      </ul>

                      <div className='change_password_wrapper'>
                        {' '}
                        <button
                          type='button'
                          className='margin_bottom_20 btn_full_width btn btn-primary pointer_class'
                          onClick={this.changePassword.bind(this)}
                        >
                          <i className='fa fa-key me-2' /> {language.LC().CHANGE_PASSWORD}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ProfileInfo
              props={this.props}
              user_id={this.state.user_id}
              avatarData={this.state.avatarData}
              setIsChildChangedTrue={this.props.setIsChildChangedTrue}
            />
          </div>
        </div>
      </div>
    );
    if (this.state.ValidToken) return validRender;
    else return <Loader />;
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/views/Profile/Profile.js